<app-group-header [Heading]="'Temperatur ' + Type | translate"
                  [chart]="chart"
                  [info]="info"
                  [noText]="true"
                  [noChart]="true"
                  [noInfo]="true"
                  (chartEvent)="getChartEvent($event)"
                  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Error]="Temp?.isError"
                      [ErrorLevel]="Temp?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Temp?.TimeseriesData]"
                      [Unit]="'°C'"
                      [min]="0"
                      [max]="60"
                      [Legend]="[Type | translate]"
                      [resizeEvent]="childResizeEvent"
                      [ChartType]="'gauge'"></app-default-card>

</div>
<!--[Heading]="'Temperatur ' + Type | translate"-->
